module.exports = __webpack_public_path__ + "static/img/preview-05.e31301e9.webp";